module.exports = require("./lib/index");


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web@0.2/node_modules/_@bone_web@0.2.0-alpha.7@@bone/web/index.js
// module id = 2435
// module chunks = 4